import React from 'react';
import SeriesCompareScatterChart from '../../components/charts/SeriesCompareScatterChart';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';


class OptimizationFullView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.handlePageSelected = this.handlePageSelected.bind(this);
    }

    componentDidMount() {
        //this.createVisualization(this.props.data, this.props.width, this.props.height);
    }

    componentDidUpdate() {

    }

    handlePageSelected(item) {
        //navigate
    }

    render() {

        const { classes } = this.props;
        let index = 0;
        const chart = this.props.data.charts[index];
        
        return (
            <div>
                <Grid container spacing={8}>
                    <Grid item xs={8}>
                        <Typography>{chart.title}</Typography>
                        <SeriesCompareScatterChart width={800} height={800} {...this.props} key={chart.id + "_" + index} series={chart.series} onItemClick={this.handlePageSelected} />
                    </Grid>
                    <Grid item xs={4}>
                        <Paper>
                        <List 
                            component="nav"
                            subheader={<ListSubheader component="div">Top priority pages</ListSubheader>}>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                /home has a potential of increasing conversions by 32% if it's compared to average page conversion rate.
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                Traffic to /features from organic search has dropped 87% in the last 30 days.
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                Traffic to /features does not have any optimization running, but has high traffic.
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                Visitors from Japan have increased 192% on /community over the last 30 days.
                            </ListItem>
                        </List>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}


export default OptimizationFullView;


// WEBPACK FOOTER //
// ./src/pages/details/OptimizationFullView.js